/**
 * OTP (One-Time Password) Types
 *
 * Defines types for OTP-based authentication: signup, login, password reset
 */
/**
 * OTP Type - Delivery method for OTP
 */
export var OTPType;
(function (OTPType) {
    OTPType["EMAIL"] = "EMAIL";
    OTPType["PHONE"] = "PHONE";
})(OTPType || (OTPType = {}));
/**
 * OTP Purpose - What the OTP is used for
 */
export var OTPPurpose;
(function (OTPPurpose) {
    OTPPurpose["SIGNUP"] = "SIGNUP";
    OTPPurpose["LOGIN"] = "LOGIN";
    OTPPurpose["PASSWORD_RESET"] = "PASSWORD_RESET";
    OTPPurpose["VERIFICATION"] = "VERIFICATION";
})(OTPPurpose || (OTPPurpose = {}));
